/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftMetadata } from './NftMetadata';
import {
    NftMetadataFromJSON,
    NftMetadataFromJSONTyped,
    NftMetadataToJSON,
    NftMetadataToJSONTyped,
} from './NftMetadata';

/**
 * 
 * @export
 * @interface NftTrackersMetadataBatchItem
 */
export interface NftTrackersMetadataBatchItem {
    /**
     * 
     * @type {string}
     * @memberof NftTrackersMetadataBatchItem
     */
    ownershipId: string;
    /**
     * 
     * @type {NftMetadata}
     * @memberof NftTrackersMetadataBatchItem
     */
    metadata: NftMetadata;
}

/**
 * Check if a given object implements the NftTrackersMetadataBatchItem interface.
 */
export function instanceOfNftTrackersMetadataBatchItem(value: object): value is NftTrackersMetadataBatchItem {
    if (!('ownershipId' in value) || value['ownershipId'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function NftTrackersMetadataBatchItemFromJSON(json: any): NftTrackersMetadataBatchItem {
    return NftTrackersMetadataBatchItemFromJSONTyped(json, false);
}

export function NftTrackersMetadataBatchItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftTrackersMetadataBatchItem {
    if (json == null) {
        return json;
    }
    return {
        
        'ownershipId': json['ownershipId'],
        'metadata': NftMetadataFromJSON(json['metadata']),
    };
}

export function NftTrackersMetadataBatchItemToJSON(json: any): NftTrackersMetadataBatchItem {
    return NftTrackersMetadataBatchItemToJSONTyped(json, false);
}

export function NftTrackersMetadataBatchItemToJSONTyped(value?: NftTrackersMetadataBatchItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ownershipId': value['ownershipId'],
        'metadata': NftMetadataToJSON(value['metadata']),
    };
}

